export const extractIDs = (data, key='id', removeDuplicates=false) => {
  try {
    if (!Array.isArray(data)) {
      throw new Error("Invalid data: must be an array");
    }

    let ids = data.map(item => item[key]);

    if (removeDuplicates) {
      ids = [...new Set(ids)];
    }

    return ids;
  } catch (error) {
    console.log(error);
    return [];
  }
}
